@if (isMobile()) {
  <div class="side-content">
    <sd-current-profile></sd-current-profile>
    <sd-my-account-navigation></sd-my-account-navigation>
    <sd-logout-from-current-device></sd-logout-from-current-device>
    <sd-logout-from-all-devices></sd-logout-from-all-devices>
  </div>
}
<div class="body">
  @if (isTablet()) {
    <sd-loyalty-qr-card></sd-loyalty-qr-card>
  }
</div>
